import http from "@/shared/services/http";

export const createCustomerService = (data: any) => http.post(`v1/customer-service`, data);
export const singleCustomerService = (id: any) => http.get(`v1/customer-service/${id}`);
export const updateCustomerService = (id: any, data: any) => http.put(`v1/customer-service/${id}`, data);
export const deleteCustomerService = (id: any) => http.delete(`v1/customer-service/${id}`);
export const listCustomerService = (params: any) => http.get(`v1/customer-service`, { params });
